/** @format */

export const blacklistUser = ["dept3telkom@gmail.com"];
